import { AxiosResponse } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { $axios } from './axios'

export type SearchTermWithCount = {
  searchTerm: string
  count: number
}

export const createSearchTerm = (
  searchTerm: string
): Promise<AxiosResponse<void>> => {
  return $axios.post('/analytics/search-terms', { searchTerm })
}

export const getSearchTerms = (): Promise<AxiosResponse<SearchTermWithCount[]>> => {
  return $axios.get('/analytics/search-terms')
}

export const useSearchTermsQuery = (
  options?: Omit<UseQueryOptions<SearchTermWithCount[], Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<SearchTermWithCount[], Error>({
    queryKey: ['searchTerms'],
    queryFn: async () => {
      const res = await getSearchTerms()
      return res.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - liberal caching
    gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for a long time
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options
  })
}
